type TFuncNames = keyof Window['HeZi']

function request(url: string, method: 'POST' | 'GET', data: string, contentType: string, callbackId: string) {
    if (!window?.HeZi?.request) {
        return Promise.reject(new Error('request function not exist in HeZi'))
    }
    return window?.HeZi?.request(url, method, data, contentType, callbackId)
}

function getUserInfo(callbackId:string) {
    if (!window?.HeZi?.request) {
        return Promise.reject(new Error('request function not exist in HeZi'))
    }
    return window?.HeZi?.getUserInfo(callbackId)
}

function setActivityResult(result: string) {
    if (!window?.HeZi?.setActivityResult) {
        return Promise.reject(new Error('request function not exist in HeZi'))
    }
    return window.HeZi.setActivityResult(result)
}

function getStatusBarHeight(callbackId: string) {
    if (!window?.HeZi?.getStatusBarHeight) {
        return Promise.reject(new Error('request function not exist in HeZi'))
    }
    return window.HeZi.getStatusBarHeight(callbackId)
}

const funcMap = {
    request,
    getUserInfo,
    setActivityResult,
    getStatusBarHeight
}

const briage = {
    uniqueId: 1,
    // caches: {},
    callHandler: function <T = any>(funcName: TFuncNames, callback: ((err: string | null, result?: T) => void) | null, ...args: unknown[]) {
       if (callback) {
           const responseCallbackId = `${funcName}_${briage.uniqueId++}_${new Date().getTime()}`
           // @ts-ignore
           window[responseCallbackId] = function responseCallback(result) {
               if (result?.error) {
                   callback(result?.error)
               } else {
                   if (result?.success) {
                       callback(null, result?.success)
                   } else {
                       callback(null, result)
                   }
               }
               // @ts-ignore
               delete window[responseCallbackId]
           }
           // @ts-ignore
           funcMap[funcName](...args, responseCallbackId)
       } else {
           // @ts-ignore
           funcMap[funcName](...args)
       }
    },
    get isAndroidNative () {
        return !!window?.HeZi
    }
}

export default briage